// ─── src/admin/components/LoginModal.jsx ─────────────────────────
import React, { useState } from 'react';
import { auth } from '../../common/firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';
import '../styles/LoginModal.css';


export default function LoginModal() {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');

  // ──────────────────────────────────────────────────────────────
  // 1️⃣ 관리자 로그인 함수
  // ──────────────────────────────────────────────────────────────
  const submit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch {
      setError('⚠️ 이메일 또는 비밀번호가 틀렸습니다.');
    }
  };


  // ──────────────────────────────────────────────────────────────
  // 2️⃣ UI
  // ──────────────────────────────────────────────────────────────
  return (
    <div className="login-modal-backdrop">
      <div className="login-modal">
        <h2>관리자 로그인</h2>

        <form onSubmit={submit}>
          {error && <p className="login-error">{error}</p>}

          <label>
            이메일
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="username"
              required
            />
          </label>

          <label>
            비밀번호
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
          </label>

          <button type="submit">로그인</button>
        </form>
      </div>
    </div>
  );
}
